/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import t from"./Dictionary.js";class e extends t{constructor(t,e,i,s,l,a){super(),this.attachmentUrl=l,this.immutable=!1,this.setField("id",t),this.setField("name",e),this.setField("contenttype",i),this.setField("size",s),this.setField("exifinfo",a),this.immutable=!0}}export{e as default};
